<template>
  <li :class="filterCssClasses">
    <button
      class="filter-button reset-button-style"
      @click="$emit('filter-click', value)"
    >
      {{ name }}
    </button>
  </li>
</template>

<script>
  export default {
    props: {
      cssPrefix: { type: String, required: true },
      name: { type: String, required: true },
      value: { type: String, required: true },
      selected: { type: Boolean, required: true }
    },
    computed: {
      filterCssClasses() {
        const classesAlwaysUsed = `${this.cssPrefix}-filter filter-analytics`;
        return this.selected ? `${classesAlwaysUsed} selected` : classesAlwaysUsed;
      }
    }
  };
</script>
